import cloneDeep from 'lodash/fp/cloneDeep'
import { listDifferenceComputer } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
import { events as containerEvents } from '../../AdviserProfileApprovalEditorContainer/adviserProfileApprovalEditorContainerActions'
import {
  PENDING_APPROVAL_START_EDITING_CLIENT_TYPES
  , PENDING_APPROVAL_STOP_EDITING_CLIENT_TYPES
  , PENDING_APPROVAL_CANCEL_EDITING_CLIENT_TYPES
  , PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_FETCHED_CLIENT_TYPES
  , PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_CLIENT_TYPE_SELECTED_CHANGED
} from './adviserProfileClientTypesEditorActions'

import { validiateChecklistField } from '../../../../../common/forms/validationFunctions'

const initialState = {
  loadingClientTypes: false,
  editingClientTypes: false,
  clientTypesBeforeEditing: [],
  allClientTypes: [],
  isInvalid: {
    formIsValid: true,
    clientTypes: {
      isInvalid: false,
      message: null
    }
  },
  profileModifications: []
}

const minimumRequiredSelection = 1

export default function (state = initialState, action) {
  var newState = copyClientTypePreferencesState(state)

  switch (action.type) {
    case containerEvents.fetch.fetched:
      newState.clientTypes.profileModifications = findClientTypePreferenceListDifferences(newState)
      return newState
    case PENDING_APPROVAL_START_EDITING_CLIENT_TYPES:
      newState.clientTypes.editingClientTypes = true
      newState.clientTypesBeforeEditing = newState.pendingApprovalProfile.clientTypePreferences
      newState.clientTypes.isInvalid.clientTypes = validiateChecklistField(newState.pendingApprovalProfile.clientTypePreferences, minimumRequiredSelection)
      newState.clientTypes.isInvalid.formIsValid = formIsValid(newState.clientTypes.isInvalid)
      return newState
    case PENDING_APPROVAL_STOP_EDITING_CLIENT_TYPES:
      newState.clientTypes.editingClientTypes = false
      return newState
    case PENDING_APPROVAL_CANCEL_EDITING_CLIENT_TYPES:
      newState.clientTypes.editingClientTypes = false
      newState.pendingApprovalProfile.clientTypePreferences = cloneDeep(newState.clientTypesBeforeEditing)
      newState.clientTypesBeforeEditing = []
      newState.clientTypes.profileModifications = findClientTypePreferenceListDifferences(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_FETCHED_CLIENT_TYPES:
      newState.clientTypes.allClientTypes = action.payload
      return newState
    case PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_CLIENT_TYPE_SELECTED_CHANGED:
      const selectedClientTypes = newState.pendingApprovalProfile.clientTypePreferences || []
      const exists = selectedClientTypes.some(
        ct => ct.clientTypeId === action.clientType.clientTypeId
      )

      const updatedClientTypes = exists
        ? selectedClientTypes.filter(ct => ct.clientTypeId !== action.clientType.clientTypeId)
        : [...selectedClientTypes, action.clientType]

      newState.pendingApprovalProfile = {
        ...newState.pendingApprovalProfile,
        clientTypePreferences: updatedClientTypes
      }

      newState.clientTypes.isInvalid.clientTypes = validiateChecklistField(updatedClientTypes, minimumRequiredSelection)
      newState.clientTypes.isInvalid.formIsValid = formIsValid(newState.clientTypes.isInvalid)
      newState.clientTypes.profileModifications = findClientTypePreferenceListDifferences(newState)
      newState.edited = true
      return newState
  }
  return state
}

function copyClientTypePreferencesState (state) {
  var newState = cloneDeep(state)
  newState.pendingApprovalProfile = cloneDeep(state.pendingApprovalProfile)
  if (state.pendingApprovalProfile) {
    newState.pendingApprovalProfile.clientTypePreferences = cloneDeep(state.pendingApprovalProfile.clientTypePreferences)
  }
  return newState
}

function formIsValid (isInvalid) {
  return !isInvalid.clientTypes.isInvalid
}

function findClientTypePreferenceListDifferences (state) {
  var oldList = state.publishedProfile.clientTypePreferences
  var newList = state.pendingApprovalProfile.clientTypePreferences
  return listDifferenceComputer(oldList, newList, 'clientTypeId')
}
